import { render, staticRenderFns } from "./UserContext.vue?vue&type=template&id=2e955498"
import script from "./UserContext.vue?vue&type=script&lang=js"
export * from "./UserContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports